module.exports = __webpack_public_path__ + "img/photo6.afaadac2.png";